/**
 * Single source for the staff/admin panel routes (D1, route rename without
 * redirects). `js/main.js` registers one route per entry and uses
 * `panelForPath` for `isAdminRoute`; `js/admin.js`'s `renderAdmin` derives its
 * default panel from the CURRENT URL through the same helper, so a re-render
 * without an explicit panel (login, logout, SIGNED_OUT) can never pick the
 * panel from leftover module state.
 *
 * Kept outside `js/admin.js` on purpose: tests that mock the admin module
 * (main bootstrap) still need the real route map.
 */

/** @type {Readonly<Record<string, 'staff'|'admin'>>} */
export const PANEL_ROUTES = Object.freeze({
    '/staff': 'staff',
    '/admin': 'admin',
});

/**
 * Panel for a pathname, tolerating trailing slashes (`/admin/` → `'admin'`).
 * @param {string} pathname
 * @returns {'staff'|'admin'|null} `null` when the path is not a panel route.
 */
export function panelForPath(pathname) {
    const path = String(pathname ?? '').replace(/\/+$/, '') || '/';
    return Object.hasOwn(PANEL_ROUTES, path) ? PANEL_ROUTES[path] : null;
}
